import { SupportedLocale } from './SupportedLocale';

export function normalizeLocale(locale: string): SupportedLocale {
  const normalizedLocale = locale.replace(/_/g, '-');
  if (Object.values(SupportedLocale).includes(normalizedLocale as SupportedLocale)) {
    return normalizedLocale as SupportedLocale;
  }

  return IS_GLOBAL ? SupportedLocale.EN_US : SupportedLocale.ZH_CN;
}
